import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../SurveyStyles.scss";
import Loader from "../../../components/Common/Loader";
import { scrollToElement } from "../../../helpers/utils";
import SurveyFooter from "./SurveyFooter";
import CSFQuestionModule from "../../../components/UI/Questionaire/Admin/CSFSurvey/CSFQuestionModule";
import SurveyHeader from "../SurveyHeader";
import { Spin } from "antd";
import {
  fetchQuestions,
  submitCSFAnswer,
  setAssessmentComplete,
  clearCSFSurvey,
} from "../../../slices/Admin/survey-CSF.slice";
import { clearCRRSurvey } from "../../../slices/Employee/survey-CRR.slice";

export default function CSFSurvey(props) {
  const {
    isSurveyLoading,
    selectedCategory,
    selectedSection,
    selectedQuestion,
    questionData,
    submissionStatus,
  } = useSelector((state) => state.CSFSurvey);
  const dispatch = useDispatch();

  const surveyId = props?.selectedSurvey?.csf_survey_id || "";

  const questions = questionData?.section?.questions || [];

  useEffect(() => {
    if (selectedSection?.id) {
      dispatch(
        fetchQuestions({
          sectionId: selectedSection?.id,
          preSubId: surveyId,
        })
      );
    }
  }, [selectedSection?.id]);

  useEffect(() => {
    dispatch(clearCRRSurvey());
  }, []);

  useEffect(() => {
    if (selectedQuestion) {
      const element = document.getElementById(selectedQuestion);
      scrollToElement(element);
    }
  }, [selectedQuestion]);

  const surveyHeaderProps = {
    description:
      "This form is designed to assess your organization’s alignment with the Cybersecurity Framework (CSF) 2.0 GOVERN function. Please provide responses to the following questions.",
    title: "Cybrbase CSF 2.0 Governance Pre-Assessment",
    selectedSurvey: props?.selectedSurvey?.id,
    showGraphData: false,
  };
  const surveyFooterProps = {
    questionData,
    submissionStatus,
  };

  const handleAnswerSubmit = (answer, isEdit) => {
    dispatch(
      submitCSFAnswer({
        answerPayload: { ...answer, assessment_submission_id: surveyId },
        isEdit,
      })
    )
      .unwrap()
      .then((res) => {
        dispatch(setAssessmentComplete(res.has_attended_all_questions));
      });
  };

  return (
    <div className="csf-survey list-container fixed">
      <div className={"selected-survey-wrapper"}>
        {isSurveyLoading ? (
          <Loader />
        ) : (
          <>
            <SurveyHeader {...surveyHeaderProps} />
            <div
              className="goals-wrapper"
              style={{
                maxHeight: props?.selectedSurvey?.id
                  ? "calc(100vh - 219px)"
                  : "calc(100vh - 269px)",
              }}
            >
              <div className="goal-description">
                <span className="category">{selectedCategory?.name}</span>
                <br /> {selectedSection?.name}
              </div>
              {questions?.length > 0 ? (
                <div className="question-container">
                  <CSFQuestionModule
                    questions={questions}
                    setAnswer={handleAnswerSubmit}
                    isAdminView={props?.isAdminView}
                    surveyId={surveyId}
                    submissionStatus={submissionStatus}
                  />

                  <SurveyFooter {...surveyFooterProps} />
                </div>
              ) : (
                <div className="question-loader">
                  <Spin />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
